"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResizeObserver = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _resizeObserverPolyfill = _interopRequireDefault(require("resize-observer-polyfill"));

var useResizeObserver = function useResizeObserver() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$defaultWidth = _ref.defaultWidth,
      defaultWidth = _ref$defaultWidth === void 0 ? 0 : _ref$defaultWidth,
      _ref$defaultHeight = _ref.defaultHeight,
      defaultHeight = _ref$defaultHeight === void 0 ? 0 : _ref$defaultHeight;

  var ref = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(defaultWidth),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultHeight),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      height = _useState4[0],
      setHeight = _useState4[1];

  (0, _react.useEffect)(function () {
    var element = ref.current;

    if (!element) {
      return;
    }

    var resizeObserver = new _resizeObserverPolyfill.default(function (entries) {
      if (!entries.length) {
        return;
      }

      var _entries = (0, _slicedToArray2.default)(entries, 1),
          entry = _entries[0];

      setWidth(entry.contentRect.width);
      setHeight(entry.contentRect.height);
    });
    resizeObserver.observe(element);
    return function () {
      return resizeObserver.unobserve(element);
    };
  }, [ref]);
  return {
    ref: ref,
    width: width,
    height: height
  };
};

exports.useResizeObserver = useResizeObserver;